var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal-fade"}},[_c('div',{staticClass:"modal-backdrop"},[_c('div',{staticClass:"modal-box",attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }